import styled from 'styled-components';
import { media, mediaQuery } from '../../../common/styles/styleUtil';

interface RecommendedWrapperProps {
  isOnContentPage?: boolean;
  isOnPovPage?: boolean;
}
export const RecommendedWrapper = styled.div<RecommendedWrapperProps>`
  padding-bottom: 80px;
  @media (${mediaQuery.tablet}) {
    padding: 40px 24px;
  }
  ${media.xs`
    padding-left: 16px;
    padding-right: 16px;
    padding-bottom: 8px;
  `};
  &.recommended-mobile {
    display: none;
    @media (${mediaQuery.tablet}) {
      display: block;
    }
  }
`;

export const TitleWrapper = styled.div`
  h2 {
    color: #333f48;
    font-size: 24px;
    line-height: 28px;
    font-weight: 500;
    margin: 0 0 16px;
  }
`;

export const RecommendedItemWrapper = styled.div<RecommendedWrapperProps>`
  @media (${mediaQuery.tablet}) {
    display: flex;
    justify-content: start;
    box-shadow: 0 1px 4px 0 rgba(0, 0, 0, 0.35);
  }
  ${media.xs`
    display: block;
    box-shadow: none;
  `};
`;

export const VideoWrapper = styled.div`
  position: relative;
  .anticon {
    position: absolute;
    margin: auto;
    width: 64px;
    height: 64px;
    top: 0;
    right: 0;
    bottom: 0;
    left: 0;
    cursor: pointer;
  }
  img {
    width: 360px;
    height: 220px;
    object-fit: cover;
    background-color: #000000;
    ${media.xs`
      width: 100%;
      height: 210px;
    `}
  }
`;

export const RecommendedDescription = styled.div`
  width: 100%;
  @media (${mediaQuery.tablet}) {
    padding: 24px 16px;
  }
  ${media.xs`
    padding: 24px 0;
  `};
`;

export const RecommendedPostType = styled.div`
  p {
    margin: 16px 0 0;
    text-transform: uppercase;
    font-size: 14px;
    line-height: 14px;
    font-weight: 300;
    @media (${mediaQuery.tablet}) {
      margin: 0;
    }
  }
`;

export const RecommendedTitle = styled.div`
  margin: 4px 0 0;
  color: #333f48;
  a {
    font-size: 18px;
    font-weight: 400;
    line-height: 26px;
    display: -webkit-box;
    color: #333f48;
    text-decoration: none;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    max-height: 52px;
  }
  a:hover {
    color: inherit;
  }
`;

export const RecommendedInfo = styled.div`
  margin-top: 16px;
  font-weight: 300;
  p {
    margin: 0;
    a {
      font-weight: 400;
    }
  }
`;
